<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :onFetchData="onFetchData"
    :actions="actions"
    :onFormSubmit="handleSubmit"
    :form="form"
    :title="$t('menu.redPacketSettings')"
    resource="settings"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class redPacketSettings extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [];
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns() {
    return [
      {
        prop: 'explore_page_red_package_code',
        label: this.$t('setting.explorePageRedPackageCode'),
        renderCell: (h, { props: { scope: { row } } }) => {
          if (row && row.explore_page_red_package) {
            return <bean-link KeepNode to={{ name: 'red_packets.show', params: { id: row.explore_page_red_package.id } }}>{
              `${row.explore_page_red_package.code} - ${row.explore_page_red_package.brand.name}`
            }</bean-link>;
          }
        }
      },
      {
        prop: 'joga_red_package_code',
        label: this.$t('setting.jogaRedPackageCode'),
        renderCell: (h, { props: { scope: { row } } }) => {
          if (row && row.joga_red_package) {
            return <bean-link KeepNode to={{ name: 'red_packets.show', params: { id: row.joga_red_package.id } }}>{
              `${row.joga_red_package.code} - ${row.joga_red_package.brand.name}`
            }</bean-link>;
          }
        }
      },
    ].filter(Boolean);
  }

  async onFetchData() {
    if (this.type === 'edit' || this.type === 'show') {
      const data = await this.$request.get('/settings');
      return {  data }
    }
  }

  async handleSubmit({ data }) {
    try {
      this.formLoading = true;
      let body = data;
      await this.$request.put('/settings', body);
      this.$message.success(this.$t('bean.updateSuccess'));
      this.$router.push({ name: 'red_packet_settings.show' });
    } finally {
      this.formLoading = false;
    }
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns() {
    return [
      {
        prop: 'explore_page_red_package_code',
        label: this.$t('setting.explorePageRedPackageCode'),
        renderCell: {
          component: 'select',
          props: {
            filterable: true,
            clearable: true,
            xRemotePreload: async () => {
              const { data } = await this.$request.get('/red_packets/read_options', { type_not_eq: 'RedPacket::Normal', per_page: 100 })
              return data.map(({ code, brand }) => ({ label: `${code} - ${brand.name}`, value: code }))
            },
            xRemoteSearch: async (keyword) => {
              const { data } = await this.$request.get('/red_packets/read_options', { keyword, type_not_eq: 'RedPacket::Normal' })
              return data.map(({ code, brand }) => ({ label: `${code} - ${brand.name}`, value: code }))
            },
          },
          domProps: {
            style: 'width: 100%'
          }
        }
      },
      {
        prop: 'joga_red_package_code',
        label: this.$t('setting.jogaRedPackageCode'),
        renderCell: {
          component: 'select',
          props: {
            filterable: true,
            clearable: true,
            xRemotePreload: async () => {
              const { data } = await this.$request.get('/red_packets/read_options', { type_eq: 'RedPacket::Joga', per_page: 100 })
              return data.map(({ code, brand }) => ({ label: `${code} - ${brand.name}`, value: code }))
            },
            xRemoteSearch: async (keyword) => {
              const { data } = await this.$request.get('/red_packets/read_options', { keyword, type_eq: 'RedPacket::Joga' })
              return data.map(({ code, brand }) => ({ label: `${code} - ${brand.name}`, value: code }))
            },
          },
          domProps: {
            style: 'width: 100%'
          }
        }
      },
    ].filter(Boolean);
  }

   /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions() {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('update'),
          to: { name: 'red_packet_settings.edit' },
          can: 'settings.update'
        }
      }
    ].filter(Boolean);
  }
}


export const route = [
  {
    path: '/settings/red_packets',
    name: 'red_packet_settings.show',
    component: redPacketSettings,
    props: {
      type: 'show'
    },
    meta: {
      backBtn: true
    }
  },
  {
    path: '/settings/red_packets/edit',
    name: 'red_packet_settings.edit',
    component: redPacketSettings,
    props: {
      type: 'edit',
    }
  },
]
</script>

<style scoped lang="scss">
  /deep/.admin-static-nest-form {
    .el-form-item {
      margin-bottom: 20px;
    }

    .el-form {
      margin-top: 25px;
    }
  }
</style>
